import TheGrid from '@/views/products/categories/grid'
import Edit from '@/views/products/categories/edit'

export default {
  path: '/products/categories',
  redirect: '/products/categories/index',
  name: 'categories',
  meta: {
    auth: {
      redirect: {
        name: 'categories.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'categories.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'categories.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'categories.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
